import React from 'react'
import { Box, Fade, useTheme } from 'webbook-airways'

export function Header({ variant, children }) {
  const theme = useTheme()
  const height = variant === 'tabs' ? 38 : 46
  return (
    <Fade in>
      <Box
        vAlign="center"
        hAlign="space-between"
        style={{
          height,
          minHeight: height,
          maxHeight: height,
          backgroundColor: 'white',
          borderBottom: '1px solid #eee',
          boxShadow: theme.shadows[1],
          position: 'relative',
          zIndex: 1
        }}
      >
        {children}
      </Box>
    </Fade>
  )
}
